export default function languageReducer(state: string = 'en', action: any) {
    switch (action.type) {
        case 'en':
            return 'en'
        case 'b5':
            return 'b5'
        default:
            return state;
    }
}